<template>
  <ZigzagServiceLayout
    mainTitle="Armonización Facial e Inyectables"
    mainDescription="Nuestros tratamientos expertos con neurotoxinas y rellenos dérmicos están diseñados para suavizar las arrugas, restaurar el volumen y realzar sus características."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'FacialHarmonizationContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ANTIENVEJECIMIENTO',
          title: 'Neurotoxinas (Botox/Dysport)',
          subtitle: 'Suaviza las líneas finas y las arrugas de expresión.',
          paragraphs: [
            "Las neurotoxinas como Botox y Dysport ofrecen una forma segura, rápida y efectiva de suavizar temporalmente las arrugas dinámicas causadas por los movimientos faciales repetitivos.",
            "Al relajar los músculos, estos tratamientos suavizan las patas de gallo y las líneas de expresión, dejándole con un aspecto refrescado."
          ],
          list: [
            "Procedimiento rápido y mínimamente invasivo",
            "Se enfoca en las líneas de expresión y arrugas",
            "Los resultados suelen durar de 3 a 4 meses",
            "Previene la formación de arrugas más profundas"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/dsy8tUMNyIs',
            'https://www.youtube.com/embed/LM2IEIQ-mC8'
          ]
        },
        {
          label: 'VOLUMEN Y CONTORNO',
          title: 'Rellenos Dérmicos (Dermal Fillers)',
          subtitle: 'Restaure el volumen perdido y mejore los contornos faciales.',
          paragraphs: [
            "A medida que envejecemos, nuestra piel pierde su elasticidad y volumen. Los rellenos dérmicos utilizan ácido hialurónico para rellenar la piel de manera segura.",
            "Ya sea que desee realzar sus labios, definir sus pómulos o rellenar pliegues profundos, los rellenos proporcionan un levantamiento inmediato."
          ],
          list: [
            "Restaura el volumen juvenil en mejillas y labios",
            "Suaviza líneas profundas y pliegues faciales",
            "Resultados inmediatos, visibles y naturales",
            "Los efectos pueden durar de 6 a 18 meses"
          ],
          image: '/images/services/facial-harm.png'
        }
      ]
    };
  }
};
</script>
